import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import styles from './styles.module.scss';
import cx from 'classnames';
import { POC_TAG_SOURCES } from './constants';
import ClockIcon from '@cp/assets/icons/ClockIcon';
import React from 'react';
import { ICallHistory } from '@cp/components/CallHistory/interfaces';
import CallHistory from '@cp/components/CallHistory/CallHistory';
import { IPhoneNumberLimit } from '@cp/pages/CaseDetails/interfaces/CaseDetail.type';
import dayjs from 'dayjs';
import { LIMIT_CALLS } from '@cp/src/constants/Common.constants';

const PocNumbersTag = ({
  source,
  number,
  option,
  callHistory,
  dailyLimit,
  hourlyLimit
}: {
  source: POC_TAG_SOURCES;
  number?: string;
  option?: string;
  callHistory?: ICallHistory[];
  dailyLimit?: IPhoneNumberLimit;
  hourlyLimit?: IPhoneNumberLimit;
}) => {
  if (source === POC_TAG_SOURCES.CONTACT_TAB) {
    return (
      <div className="relative w-[153px] h-[26px] bg-bg-secondary ml-[-16px] rounded-r-[1px] rr-block">
        <Tooltip placement="top" hiddenPadding={10} hideStrategy="referenceHidden">
          <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
            <div className="flex justify-between gap-[10px]">
              <div className="w-[124x] h-[26px] bg-[#EFE3FC] pl-[15px] pr-[19px] flex items-center">
                <div className="w-[95px] text-grayscale-1">{number}</div>
                <div className={cx(styles.triangleDown, 'right-[30.5px] translate-x-2/4')} />
              </div>
              <Typography
                variant="p5"
                className=" flex items-center justify-start w-full text-grayscale-2 ml-[-10px]"
              >
                Try
              </Typography>
            </div>
          </TooltipTrigger>
          <TooltipContent className={styles.tooltipWrapper}>
            New number added. Try calling on them
          </TooltipContent>
        </Tooltip>
      </div>
    );
  } else if (source === POC_TAG_SOURCES.FEEDBACK_FORM) {
    return (
      <div className="flex flex-wrap gap-x-[10px] gap-y-0 w-[100%] rr-block">
        <div className="flex justify-between items-center w-[100%]">
          <div className="relative w-[153px] h-[26px] bg-bg-secondary ml-[-12px] rounded-r-[1px]">
            <Tooltip placement="left" hiddenPadding={10} hideStrategy="referenceHidden">
              <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
                <div className="flex justify-between gap-[10px]">
                  <div className="w-[124x] h-[26px] bg-[#EFE3FC] pl-[15px] pr-[19px] flex items-center">
                    <div className="w-[88px] text-grayscale-1 pr-[5px] text-sm">{option}</div>
                    <div className={cx(styles.triangleDown)} />
                  </div>
                  <Typography
                    variant="p5"
                    className=" flex items-center justify-start w-full text-grayscale-2 ml-[-9px]"
                  >
                    Try
                  </Typography>
                </div>
              </TooltipTrigger>
              <TooltipContent className={styles.tooltipWrapper}>
                New number added. Try calling on them
              </TooltipContent>
            </Tooltip>
          </div>
          {callHistory && <CallHistory list={callHistory} noOfRecords={5} />}
        </div>
        {dailyLimit?.callRemaining === 0 ? (
          <div className="flex items-center gap-[4px] mt-[8px]">
            <ClockIcon />
            <Typography variant="h5" color="var(--grayscale-2)">
              {LIMIT_CALLS.NEXT_CALL_ATTEMPT}
              <Typography variant="h5" as="span" color="var(--orange-darkbase)">
                {LIMIT_CALLS.TOMORROW}
              </Typography>
            </Typography>
          </div>
        ) : hourlyLimit?.nextCallingTime ? (
          <div className="flex items-center gap-[4px] mt-[8px]">
            <ClockIcon />
            <Typography variant="h5" color="var(--grayscale-2)">
              {LIMIT_CALLS.NEXT_CALL_ATTEMPT}
              {dayjs(hourlyLimit?.nextCallingTime).isAfter(dayjs(), 'day') ? (
                <Typography variant="h5" as="span" color="var(--orange-darkbase)">
                  {LIMIT_CALLS.TOMORROW}
                </Typography>
              ) : (
                <Typography variant="h5" as="span" color="var(--orange-darkbase)">
                  {dayjs(hourlyLimit?.nextCallingTime).format('h:mm A')}
                </Typography>
              )}
            </Typography>
          </div>
        ) : null}
      </div>
    );
  } else {
    return null;
  }
};

export default PocNumbersTag;
